import React from 'react';

interface FilterChipProps {
  label: string;
  icon?: string;
  count: number;
  active: boolean;
  onClick: () => void;
  disabled?: boolean;
}

export const FilterChip: React.FC<FilterChipProps> = ({ 
  label, 
  icon, 
  count, 
  active, 
  onClick,
  disabled = false
}) => {
  return (
    <button
      onClick={onClick}
      disabled={disabled || count === 0}
      className={`
        flex items-center gap-2 px-3 py-1.5 rounded-full text-xs font-medium
        whitespace-nowrap transition-all
        ${active 
          ? 'bg-primary text-primary-foreground shadow-sm' 
          : 'bg-muted text-muted-foreground hover:bg-muted/80'
        }
        ${(disabled || count === 0) ? 'opacity-50 cursor-not-allowed' : ''}
      `}
    >
      {icon && <span className="text-sm">{icon}</span>}
      <span>{label}</span>
      <span className={`
        px-1.5 py-0.5 rounded-full text-[10px] font-semibold
        ${active ? 'bg-primary-foreground/20' : 'bg-background/50'}
      `}>
        {count}
      </span>
    </button>
  );
};
